module.exports = __webpack_public_path__ + "static/media/poster.8d1c2f21.jpg";